import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export function bundleFormValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const group = control as FormGroup;
    const image = group.get('productImage')?.value;
    const imageDesc = group.get('imageDescription')?.value;

    if (image && !imageDesc) {
      return {imageDescriptionRequired: true};
    }

    return null;
  };
}
